"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultStyledInputTextBox = void 0;
exports.createTextboxPropertySelector = createTextboxPropertySelector;
const react_1 = __importDefault(require("react"));
const property_1 = require("@promaster-sdk/property");
const defaultStyledInputTextBox = (props) => (react_1.default.createElement("input", Object.assign({}, props, { style: {
        color: "black",
        height: "30px",
        border: "1px solid #b4b4b4",
        borderRadius: "3px",
        font: "normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif",
        outline: "rgb(131, 131, 131) none 0px",
        padding: "1px 30px 0px 10px"
    } })));
exports.defaultStyledInputTextBox = defaultStyledInputTextBox;
function createTextboxPropertySelector({ StyledInputTextBox = exports.defaultStyledInputTextBox }) {
    return class TextboxPropertySelector extends react_1.default.Component {
        constructor(props) {
            super(props);
            // What the optimal debounce is may vary between users. 350ms seems like a nice value...
            this._debouncedOnValueChange = debounce(this._debouncedOnValueChange, this.props.debounceTime);
        }
        componentWillMount() {
            const { propertyName, propertyValueSet } = this.props;
            const value = property_1.PropertyValueSet.getText(propertyName, propertyValueSet);
            this.setState({ textValue: value || "" });
        }
        componentWillReceiveProps(nextProps) {
            const { propertyName, propertyValueSet } = nextProps;
            const value = property_1.PropertyValueSet.getText(propertyName, propertyValueSet);
            this.setState({ textValue: value || "" });
        }
        render() {
            const { onValueChange, readOnly } = this.props;
            const { textValue } = this.state;
            return (react_1.default.createElement(StyledInputTextBox, { type: "text", value: textValue, readOnly: readOnly, onChange: e => this._onChange(e, onValueChange) }));
        }
        _debouncedOnValueChange(newValue, onValueChange) {
            onValueChange(newValue);
        }
        _onChange(e, onValueChange) {
            const newStringValue = e.target.value;
            this.setState({ textValue: newStringValue });
            this._debouncedOnValueChange(property_1.PropertyValue.create("text", newStringValue), onValueChange);
        }
    };
}
// (From underscore.js)
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    let timeout;
    return function () {
        const context = this;
        // biome-ignore lint: -
        const args = arguments;
        const later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
//# sourceMappingURL=textbox-property-selector.js.map